/**
 * Clipboard copy that never fails silently (OQA-11).
 *
 * navigator.clipboard.writeText rejects in real browsers when the document
 * is unfocused or clipboard permission is denied. The old inline handlers
 * chained only .then(...) — a rejection produced no feedback at all. This
 * helper tries the async Clipboard API first, falls back to a hidden
 * textarea + document.execCommand('copy'), and resolves a boolean so the
 * caller always shows success OR failure feedback.
 */
export async function copyText(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through to the legacy path
    }
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    textarea.remove();
    return ok;
  } catch {
    return false;
  }
}
